// extracted by mini-css-extract-plugin
module.exports = {"container":"WarningModal_container__Uys0t","message":"WarningModal_message__L-gn1","buttonContainer":"WarningModal_buttonContainer__3AKi2","button":"WarningModal_button__3kjxn"};